import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch } from 'vue';

export interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cssVars?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  accentColor?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  touchscreen?: any;
  showBlazeOverlay: boolean;
  showAlphaOverlay: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomUseSheet',
  props: /*@__PURE__*/_mergeModels({
    cssVars: { default: () => ({}) },
    accentColor: { default: () => 'accent' },
    touchscreen: { default: () => false },
    showBlazeOverlay: { type: Boolean, default: false },
    showAlphaOverlay: { type: Boolean }
  }, {
    "modelValue": {default: true},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['close', 'toggle-blaze', 'toggle-alpha'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { cssVars, touchscreen } = props;

const showUseSheet = _useModel(__props, "modelValue");

watch(() => showUseSheet, (newVal) => {
  if (!newVal) {
    emits('close');
  }
});


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_funding_acknowledgement = _resolveComponent("funding-acknowledgement")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    style: _normalizeStyle(_unref(cssVars)),
    class: "bottom-sheet",
    id: "text-bottom-sheet",
    "hide-overlay": "",
    persistent: "",
    "no-click-animation": "",
    absolute: "",
    width: "100%",
    scrim: false,
    location: "bottom",
    modelValue: showUseSheet.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showUseSheet).value = $event)),
    transition: "dialog-bottom-transition"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        id: "bottom-sheet-card",
        height: "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            id: "close-text-icon",
            class: "control-icon",
            icon: "times",
            size: "lg",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showUseSheet.value = false)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (showUseSheet.value = false), ["enter"])),
            tabindex: "0"
          }),
          _createVNode(_component_v_card_text, { class: "info-text tab-items no-bottom-border-radius scrollable" }, {
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("h3", null, "How to Use WWT", -1)),
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { align: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_chip, {
                            label: "",
                            outlined: ""
                          }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode(" Pan ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "8",
                        class: "pt-1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(_unref(touchscreen) ? "press + drag" : "click + drag"), 1),
                          _createTextVNode(" " + _toDisplayString(_unref(touchscreen) ? ":" : "or") + " ", 1),
                          _createElementVNode("strong", null, _toDisplayString(_unref(touchscreen) ? ":" : "W-A-S-D"), 1),
                          _createTextVNode(" " + _toDisplayString(_unref(touchscreen) ? ":" : "keys"), 1),
                          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { align: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_chip, {
                            label: "",
                            outlined: ""
                          }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode(" Zoom ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "8",
                        class: "pt-1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(_unref(touchscreen) ? "pinch in and out" : "scroll in and out"), 1),
                          _createTextVNode(" " + _toDisplayString(_unref(touchscreen) ? ":"
                : "or") + " ", 1),
                          _createElementVNode("strong", null, _toDisplayString(_unref(touchscreen) ? ":" : "I-O"), 1),
                          _createTextVNode(" " + _toDisplayString(_unref(touchscreen) ? ":" : "keys"), 1),
                          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "credits" }, [
                            _createElementVNode("h3", null, "Credits:"),
                            _createElementVNode("h4", null, [
                              _createElementVNode("a", {
                                href: "https://www.cosmicds.cfa.harvard.edu/",
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }, "CosmicDS"),
                              _createTextVNode(" Vue Data Stories Team:")
                            ]),
                            _createTextVNode(" John Lewis"),
                            _createElementVNode("br"),
                            _createTextVNode(" Jon Carifio"),
                            _createElementVNode("br"),
                            _createTextVNode(" Pat Udomprasert"),
                            _createElementVNode("br"),
                            _createTextVNode(" Alyssa Goodman"),
                            _createElementVNode("br"),
                            _createTextVNode(" Mary Dussault"),
                            _createElementVNode("br"),
                            _createTextVNode(" Harry Houghton"),
                            _createElementVNode("br"),
                            _createTextVNode(" Anna Nolin"),
                            _createElementVNode("br"),
                            _createTextVNode(" Evaluator: Sue Sunbury"),
                            _createElementVNode("br"),
                            _createElementVNode("br"),
                            _createElementVNode("h4", null, "WorldWide Telescope Team:"),
                            _createTextVNode(" Peter Williams"),
                            _createElementVNode("br"),
                            _createTextVNode(" A. David Weigel"),
                            _createElementVNode("br"),
                            _createTextVNode(" Jon Carifio"),
                            _createElementVNode("br")
                          ], -1)),
                          _createVNode(_component_v_spacer, { class: "end-spacer" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_funding_acknowledgement)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style", "modelValue"]))
}
}

})